
import React from 'react';

export const UpdateRSVPLoading: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-64">
      <p className="text-muted-foreground">Loading your RSVP...</p>
    </div>
  );
};
